import { AnalysisFilterState } from '../../AnalysisPage/Filter/analysisFilterState';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { TagFilterInputGq } from '../../../graphql/projects/models/TagFilterInputGq';

export function analysisFilterToKwTagFilter(
  analysisFilter: AnalysisFilterState,
  project: ProjectGq
): TagFilterInputGq[] {
  const tagFilter: TagFilterInputGq[] = [];

  // Tag group filters - we need to add all the tag ids for a specific tag group
  if (analysisFilter.shownFields.showTagGroupIds)
    analysisFilter.tagGroupIds?.forEach((tgId) =>
      project.tagGroups
        .find((tg) => tg.id === tgId)
        .tags.forEach((tg) => tagFilter.push({ tagGroupId: tgId, tagId: tg.id }))
    );

  // Tag group filter
  if (
    analysisFilter.shownFields.showTagGroupId &&
    analysisFilter.tagGroupId > 0 &&
    (!analysisFilter.tagId || analysisFilter.tagId < 0 || !analysisFilter.shownFields.showTagId)
  )
    project.tagGroups
      .find((tg) => tg.id === analysisFilter.tagGroupId)
      .tags.forEach((tg) =>
        tagFilter.push({ tagGroupId: analysisFilter.tagGroupId, tagId: tg.id })
      );

  // Tag filter
  if (
    analysisFilter.shownFields.showTagGroupId &&
    analysisFilter.shownFields.showTagId &&
    analysisFilter.tagGroupId > 0 &&
    analysisFilter.tagId > 0
  )
    tagFilter.push({
      tagGroupId: analysisFilter.tagGroupId,
      tagId: analysisFilter.tagId,
    });

  return tagFilter;
}
